import { render, staticRenderFns } from "./chainBreakTab.vue?vue&type=template&id=5cb36b88&"
import script from "./chainBreakTab.vue?vue&type=script&lang=js&"
export * from "./chainBreakTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports